import { Col, Row } from "antd";
import { profileStore } from "src/stores/profile-store";
import { useShallow } from "zustand/react/shallow";
import { useMemo } from "react";
import "../../App.css";
import CategoryGroup from "src/components/CategoryGroup";

const defaultIconStyle = { fontSize: 64, fontWeight: 300 };

const HomePage = () => {
  const profile = profileStore(useShallow((state) => state.profile));

  const homeMenus = useMemo(() => {
    const items = [
      {
        key: "setting-menu-1",
        icon: (
          <span className="material-symbols-outlined" style={defaultIconStyle}>
            source_environment
          </span>
        ),
        label: "Company",
        new_background: "#edbd5c",
        customClass: "yellow-background",
        link: "/setting/company",
      },
      {
        key: "setting-menu-2",
        icon: (
          <span className="material-symbols-outlined" style={defaultIconStyle}>
            account_circle
          </span>
        ),
        label: "User Management",
        new_background: "#edbd5c",
        customClass: "yellow-background",
        link: "/setting/user-management",
      },
      {
        key: "setting-menu-3",
        icon: (
          <span className="material-symbols-outlined" style={defaultIconStyle}>
            calculate
          </span>
        ),
        label: "Master Data",
        new_background: "#edbd5c",
        customClass: "yellow-background",
        link: "/setting/masterdata",
      },
      {
        key: "setting-menu-4",
        icon: (
          <span className="material-symbols-outlined" style={defaultIconStyle}>
            rocket_launch
          </span>
        ),
        label: "Job",
        new_background: "#edbd5c",
        customClass: "yellow-background",
        link: "/setting/job",
      },
      {
        key: "setting-menu-5",
        icon: (
          <span className="material-symbols-outlined" style={defaultIconStyle}>
            list_alt
          </span>
        ),
        label: "History",
        new_background: "#edbd5c",
        customClass: "yellow-background",
        link: "/setting/history",
      },
    ];
    return items;
  }, [profile?.roles]);

  // console.log("homeMenus :: ", homeMenus);

  const categoryMenus = useMemo(() => {
    const onlySystemAdmin = ["/setting/job", "/setting/history"];
    const isSystemAdmin = profile?.isSystemAdmin;
    if (isSystemAdmin) return homeMenus;
    else return homeMenus.filter((item) => !onlySystemAdmin.includes(item.link));
  }, [profile?.isSystemAdmin]);

  return (
    <div style={{ padding: "50px" }}>
      <Row gutter={[40, 60]} justify={"center"}>
        {categoryMenus.map((item) => (
          <Col key={item.key} xs={24} sm={12} md={8} lg={8}>
            <CategoryGroup
              link={item.link}
              customClass={item.customClass}
              new_background={item.new_background}
              label={item.label}
              icon={item.icon}
            />
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default HomePage;
